import React, { useEffect, useState } from "react";
import { useParams, Navigate, useNavigate } from "react-router-dom";

import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import Navigation from "../../components/Navigation/Navigation";
import MerchantProfil from "../../components/MerchantProfil/MerchantProfil";
import Footer from '../../components/Footer/Footer';

import { getProfil } from "../../api/Public/merchant";
import OffersPopUp from "../../components/OffersPopUp/OffersPopUp";
import { getHistory } from "../../api/Client/history";

export default function MerchantPage() {
    const { id } = useParams();
    const [merchant, setMerchant] = useState(null);
    const [redirect, setRedirect] = useState(false);
    const [history, setHistory] = useState(null);
    const navigate = useNavigate;
    const [window, setWindow] = useState(false);
    const [popUp, setPopUp] = useState(null);

    useEffect(() => {
        if (!/^\d+$/.test(id)) {
            setRedirect(true);
            return;
        }

        const load = async () => {
            const profil = await getProfil({ id: Number(id) });

            if (!profil.data || profil.data.length === 0)
                setRedirect(true);
            else
                profil.data ? setMerchant(profil.data) : setRedirect(true);

            const storedUser = JSON.parse(localStorage.getItem('user'));
            const role = storedUser?.role || 'public';
            if (role === 'client') {
                const result = await getHistory(navigate);
                setHistory(result?.data ?? []);
            }
        };

        load();
    }, [id, navigate]);

    if (redirect) return <Navigate to="/" replace />;
    if (!merchant) return <p>Chargement...</p>;

    return (
        <div>
            <Navigation />
        
            {window && <OffersPopUp setWindow={setWindow} popUp={popUp} history={history} merchant={merchant} />}

            <div style={{filter: window ? "blur(3px)" : "none", pointerEvents: window ? "none" : "auto", userSelect: window ? "none" : "auto"}}>
                <BreadCrumb />
                <MerchantProfil merchant={merchant} history={history} setHistory={setHistory} setWindow={setWindow} setPopUp={setPopUp} />
            </div>

            <Footer />
        </div>
    );
}
